import { useTranslation } from 'react-i18next';
import { useDebounceHandler } from '@lili/utils/hooks';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { REASON_FOR_OPEN_ARRAY } from './consts';
import { AccountOpeningReasonList } from './components/AccountOpeningReasonList';
import { useAccountOpeningReasonLogic } from './hooks/useAccountOpeningReasonLogic';
import { OtherAccountOpeningReasonModal } from './components/OtherAccountOpeningReasonModal';
import type { REASON_FOR_OPEN } from './consts';
export const AccountOpeningReason = () => {
  const { t } = useTranslation();
  const { debounceAction } = useDebounceHandler(2500);
  const { isOtherModalOpen, onClickItem, closeModal, mutateAsync, isPending } =
    useAccountOpeningReasonLogic();

  const delayedSubmit = (reason: string) => {
    mutateAsync(reason);
  };

  const delayedItemClick = (reason: REASON_FOR_OPEN, title: string) => {
    onClickItem(reason, title);
  };

  return (
    <StepPageWrapper heading={t('pages.accountOpeningReason.title')}>
      <AccountOpeningReasonList
        reasonList={REASON_FOR_OPEN_ARRAY}
        onClickItem={(reason, title) => debounceAction(() => delayedItemClick(reason, title))}
      />
      {isOtherModalOpen && (
        <OtherAccountOpeningReasonModal
          onSubmit={(reason: string) => debounceAction(() => delayedSubmit(reason))}
          onCancel={closeModal}
          isLoading={isPending}
        />
      )}
    </StepPageWrapper>
  );
};
